import React from 'react';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Hero } from '../components/Hero';
import { ProgramsAccordion } from '../components/ProgramsAccordion';
import { ProgramQuiz } from '../components/ProgramQuiz';
import { Testimonials } from '../components/Testimonials';
import { BeforeAfterShowcase } from '../components/BeforeAfterShowcase';
import { SectionFour } from '../components/SectionFour';

export function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const scrollToHash = () => {
      const element = document.querySelector(location.hash);

      if (element) {
        const headerHeight = 80;
        const top =
          element.getBoundingClientRect().top +
          window.pageYOffset -
          headerHeight;

        window.scrollTo({
          top,
          behavior: "smooth",
        });
      }
    };

    scrollToHash();

    const timer = setTimeout(scrollToHash, 300);

    return () => clearTimeout(timer);
  }, [location.hash]);
  
  return (
    <main>
      <HelmetProvider>
        <Helmet>
          <title>
            Get Fit with Daniella - Transform Your Fitness Journey
          </title>

          <meta
            name="description"
            content="Get Fit with Daniella offers fun, sustainable fitness programs designed to help you build healthy habits, get stronger, and transform your fitness journey."
          />

          <link rel="canonical" href="https://getfitwithdaniella.com/" />

          {/* Open Graph */}
          <meta
            property="og:title"
            content="Get Fit with Daniella - Transform Your Fitness Journey"
          />

          <meta
            property="og:description"
            content="Get Fit with Daniella offers fun, sustainable fitness programs designed to help you build healthy habits, get stronger, and transform your fitness journey."
          />

          <meta
            property="og:url"
            content="https://getfitwithdaniella.com/"
          />

          <meta property="og:type" content="website" />

          <meta
            property="og:site_name"
            content="Get Fit with Daniella"
          />

          <meta
            property="og:image"
            content="https://getfitwithdaniella.com/assets/og-image.jpg"
          />

          {/* Twitter / X */}
          <meta
            name="twitter:card"
            content="summary_large_image"
          />

          <meta
            name="twitter:title"
            content="Get Fit with Daniella - Transform Your Fitness Journey"
          />

          <meta
            name="twitter:description"
            content="Get Fit with Daniella offers fun, sustainable fitness programs designed to help you build healthy habits, get stronger, and transform your fitness journey."
          />

          <meta
            name="twitter:image"
            content="https://www.getfitwithdaniella.com/assets/og-image.jpg"
          />
        </Helmet>
      </HelmetProvider>
      <Hero />
      {/* Programs Accordion Section */}
      <ProgramsAccordion />

      {/* Program Quiz Section */}
      <ProgramQuiz />

      <Testimonials />

      <BeforeAfterShowcase />

      <SectionFour />
    </main>
  );
}
